<!--
 * @Author: cryi.liu
 * @Date: 2020-05-26 09:54:56
 * @LastEditTime: 2020-06-22 16:10:38
 * @Description: 选项修正正确答案浮层
-->
<template>
  <i-modal
    :value="modalShow"
    :mask-closable="false"
    :loading="modalLoading"
    title="修正答案"
    @on-visible-change="modalVisibleChanged"
    @on-ok="modalClickOk">
    <component
      v-if="modalShow"
      :is="renderForQuestionType"
      :options="options" @select-change="selectChangeHandler"  />
</i-modal>
</template>

<script>
import MultipleChoice from './MultipleChoice.vue';
import SingleChoice from './SingleChoice.vue';

export default {
  name: 'CorrectAnswerModal',
  props: {
    libraryId: { type: String, required: true },
    modalShow: { type: Boolean, required: true },
    questionType: { type: String, reuqired: true },
    options: { type: Array, required: true },
  },
  data() {
    return {
      renderForQuestionType: null,
      tempData: null,
      modalLoading: true,
    };
  },
  watch: {
    questionType: {
      immediate: true,
      handler(questionType) {
        if (questionType === '多选' || questionType === '不定项选择' || questionType === '填空' || questionType === '简答') {
          const tempData = [];
          this.options.forEach((option) => {
            if (option.correct) {
              tempData.push(option.id);
            }
          });

          this.tempData = tempData;
          this.renderForQuestionType = MultipleChoice;
        } else if (questionType === '单选' || questionType === '判断') {
          let tempData = '';
          this.options.forEach((option) => {
            if (option.correct) {
              tempData = option.id;
            }
          });

          this.tempData = tempData;
          this.renderForQuestionType = SingleChoice;
        }
      },
    },
  },
  methods: {
    modalVisibleChanged(state) {
      if (!state) {
        this.$emit('hide-modal');
      }
    },
    /**
     * 选项选择变化处理函数
     */
    selectChangeHandler(data) {
      this.tempData = data;
    },
    /**
     * 模态框确认处理函数
     */
    modalClickOk() {
      const tempOptions = JSON.parse(JSON.stringify(this.options));

      if (this.questionType === '多选' || this.questionType === '不定项选择' || this.questionType === '填空' || this.questionType === '简答') {
        tempOptions.forEach((option) => {
          if (this.tempData.includes(option.id)) {
            option.correct = true;
          } else {
            option.correct = false;
          }
        });
      } else if (this.questionType === '单选' || this.questionType === '判断') {
        tempOptions.forEach((option) => {
          if (option.id === this.tempData) {
            option.correct = true;
          } else {
            option.correct = false;
          }
        });
      }

      if (this.questionType === '多选') {
        let counter = 0;
        tempOptions.forEach((option) => {
          if (option.correct) {
            counter += 1;
          }
        });

        if (counter < 2) {
          alert('该题为多选题，至少设置2个正确答案');
          this.modalLoading = false;

          this.$nextTick(() => {
            this.modalLoading = true;
          });

          return;
        }
      }

      if (this.questionType === '不定项选择') {
        let counter = 0;
        tempOptions.forEach((option) => {
          if (option.correct) {
            counter += 1;
          }
        });

        if (counter < 1) {
          alert('该题不定项选择题，至少设置1个正确答案');
          this.modalLoading = false;

          this.$nextTick(() => {
            this.modalLoading = true;
          });

          return;
        }
      }

      this.requestCorrectSaveAnswerAndSettig(tempOptions);
    },
    /**
    * 请求修改选项正确答案并设置
    */
    requestCorrectSaveAnswerAndSettig(options) {
      this.requestCorrectSaveAnswer(options)
        .then(() => {
          this.$emit('repull-question-info');
          this.$emit('hide-modal');
        })
        .catch((result) => {
          alert(result.msg);
          // this.$emit('repull-question-info');
          // this.$emit('hide-modal');
        });
    },
    /**
    * 请求修改选项正确答案
    */
    requestCorrectSaveAnswer(options) {
      const params = {
        id: this.libraryId,
        options,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.librarySaveQuestion(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
